import React from 'react';
import UserMenu from '../userMenu/userMenu';
import { useLocation } from 'react-router-dom';
import { useLocalizedNavigate } from 'hooks/useLocalizedNavigate';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { CasinoIcon, SportsIcon, RewardsIcon, LogoIcon } from 'components/icons';
import styles from './header.module.scss';

interface HeaderProps {
  onLoginClick?: () => void;
  onRegisterClick?: () => void;
  onWalletClick?: () => void;
  onVipClick?: () => void;
  isLoggedIn?: boolean;
  onLogout?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  onLoginClick,
  onRegisterClick,
  onWalletClick,
  onVipClick,
  isLoggedIn = false,
  onLogout,
}) => {
  const navigate = useLocalizedNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const activeTab = location.pathname.includes('/sports') ? 'sports' : 'casino';

  return (
    <div className={styles.header_wrapper}>
      <header className={styles.header}>
        <div className={styles.header_left}>
          <div
            className={styles.logo}
            onClick={() => {
              navigate('/');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <span className={styles.logo_w}>
              <LogoIcon width={120} height={38} fill="#ffffff" />
            </span>
          </div>
          <div className={styles.category_toggle}>
            <button
              className={`${styles.toggle_btn} ${activeTab === 'casino' ? styles.active : ''}`}
              onClick={() => {
                navigate('/');
                window.scrollTo(0, 0);
              }}
            >
              <CasinoIcon />
              {t('common.casino', t('header.casino', 'Casino'))}
            </button>
            <button
              className={`${styles.toggle_btn} ${activeTab === 'sports' ? styles.active : ''}`}
              onClick={() => {
                navigate('/sports');
                window.scrollTo(0, 0);
              }}
            >
              <SportsIcon />
              {t('common.sports', t('header.sports', 'Sports'))}
            </button>
            <button className={styles.toggle_btn} onClick={() => onVipClick && onVipClick()}>
              <RewardsIcon />
              {t('common.rewards', t('header.rewards', 'Rewards'))}
            </button>
          </div>
        </div>

        <div className={styles.header_right}>
          {/* Todo: remove after discussion */}
          {/* <button className={`${styles.icon_btn} ${styles.search_btn}`} onClick={onSearchClick}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </button> */}

          {isLoggedIn ? (
            <UserMenu balance={0.0} onWalletClick={onWalletClick} onLogout={onLogout} />
          ) : (
            <div className={styles.auth_buttons}>
              <button className={styles.login_btn} onClick={onLoginClick}>
                {t('common.login', t('header.login', 'Login'))}
              </button>
              <button className={styles.sign_up_btn} onClick={onRegisterClick}>
                {t('common.signUp', t('header.signUp', 'Sign Up'))}
              </button>
            </div>
          )}
        </div>
      </header>
    </div>
  );
};

export default Header;
